import errorReporter from '@app/errorReporter';
import { angular2react } from 'angular2react';
import { lazyInjector } from '../../lazyInjector';
import { isAuthForLocation } from '../../../utils';

function PreviewButtonController($rootScope, ModalService, ListingViewService) {
  const vm = this;
  vm.$onInit = function () {
    vm.auth = $rootScope.auth;
    if (vm.listing) return;

    if (!vm.listingId)
      return errorReporter.error(
        'you must provide a listingId if there is no listing provided to the preview button',
      );
    ListingViewService.getListing(vm.listingId).then(function (listing) {
      vm.listing = listing;
    });
  };

  vm.openPreview = function () {
    if (vm.isDisabled) return;

    const { listing } = vm;
    ModalService.openPreviewModal(listing);
  };

  vm.getClass = () => {
    let classStyle = vm.hideStyling
      ? vm.className || ''
      : `btn btn-default pull-right margin-right hidden-xs eye-button ${
          vm.className || ''
        }`;

    if (vm.isDisabled) classStyle += ' disabled';
    return classStyle;
  };

  vm.authLocations = () =>
    vm.auth ? [vm.auth.location, ...(vm.auth.locations || [])] : [];

  vm.isAuthorizedForLocation = () => {
    return isAuthForLocation(vm.auth, vm.listing);
  };
}

PreviewButtonController.$inject = [
  '$rootScope',
  'ModalService',
  'ListingViewService',
];

const previewButton = {
  transclude: true,
  bindings: {
    listing: '<?',
    listingId: '@?',
    hideStyling: '<?',
    className: '<?',
    isDisabled: '<?',
  },
  controller: PreviewButtonController,
  controllerAs: 'vm',
  template: require('./preview_button.html'),
};

export const EyeballButton = angular2react(
  'bbPreviewButton',
  previewButton,
  lazyInjector.$injector,
);

export default previewButton;
